import { Box, VStack, Text, Image, Button } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import EmptyListImage from '@/assets/svg/empty-list.svg';

const EmptyRoute = () => {
  const navigate = useNavigate();

  return (
    <Box
      id="empty section"
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
    >
      <VStack spacing={4} textAlign="center">
        {/* Illustration */}
        <Box>
          <Image
            src={EmptyListImage} // Replace with actual illustration URL
            alt="Empty State Illustration"
            width="400px"
            height="auto"
          />
        </Box>

        {/* Text */}
        <Text fontSize="lg" fontWeight="bold">
          Ooops! It’s Empty
        </Text>
        <Text fontSize="md" color="gray.500">
          The page you’re looking for doesn’t exist or has been moved.
        </Text>

        {/* Button */}
        <Button
          onClick={() => navigate('/')}
          variant="solid"
          colorScheme="brand.primary"
          size="md"
          fontFamily="primary"
        >
          Go Back to Home
        </Button>
      </VStack>
    </Box>
  );
};

export default EmptyRoute;
